import { PowerSyncDatabase } from "@powersync/web";
import { psSchema, syncConnector } from "@cliqsuite/db/powersync";
import { bindCollections } from "@cliqsuite/db";

// What the platform and global buckets give an admin (powersync/sync-rules.yaml).
const schema = psSchema([
  "businesses",
  "subscription_payments",
  "subscription_discounts",
  "discount_codes",
  "audit_log",
  "subscription_plans",
  "billing_cycles",
  "module_presets",
  "payment_method_configs",
]);

export const db = new PowerSyncDatabase({ schema, database: { dbFilename: "admin.db" } });
bindCollections(db);

const IDENTITY_KEY = "cliqsuite-admin-db-identity";

/** Starts syncing for this admin; another admin on the same browser starts from an empty database. */
export async function connectAdminDb(identity: string): Promise<void> {
  let previous: string | null = null;
  try {
    previous = localStorage.getItem(IDENTITY_KEY);
    localStorage.setItem(IDENTITY_KEY, identity);
  } catch {
    previous = null;
  }
  if (previous !== identity) await db.disconnectAndClear();
  await db.connect(syncConnector());
}

export async function clearAdminDb(): Promise<void> {
  try {
    localStorage.removeItem(IDENTITY_KEY);
  } catch {
    // ignore
  }
  await db.disconnectAndClear();
}
